import EventEmitter from "./EventEmitter.js";

export default class Sizes extends EventEmitter {
    constructor() {
        super();

        // Setup
        this.width = window.innerWidth;
        this.height = window.innerHeight;
        // capping at 1.5 to avoid performance issues on high pixel ratio devices
        this.pixelRatio = Math.min(window.devicePixelRatio, 1.5);

        // Resize event
        window.addEventListener("resize", () => {
            this.width = window.innerWidth;
            this.height = window.innerHeight;
            this.pixelRatio = Math.min(window.devicePixelRatio, 1.5);

            this.trigger("resize");
        });
    }
}
